import { gql } from 'graphql-request';

export default gql`query($filter: DocumentsFilterInput) {
    documents(filter: $filter) {
        items {
            fileName
            title
            attachmentId
        }
    }
}`;
